// 预览图 宽高
const DEFAULT_PREVIEW_SIZE_WIDTH = 250
const DEFAULT_PREVIEW_SIZE_HEIGHT = 250

// 图 宽高
const DEFAULT_IMG_SIZE_WIDTH = 60
const DEFAULT_IMG_SIZE_HEIGHT = 60



export default {
    DEFAULT_PREVIEW_SIZE_WIDTH,
    DEFAULT_PREVIEW_SIZE_HEIGHT,
    DEFAULT_IMG_SIZE_WIDTH,
    DEFAULT_IMG_SIZE_HEIGHT
}